import axios from 'axios'
import router from '../../src/router'
import {
  Message
} from 'element-ui'
import {
  getStore
} from '../../src/utils/storage'
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded'
var config = {
  baseUrl: '',
  debug: false,
  isTest: true    //true=本地和正式部署  false=本地连接远程
}
'use strict';
class Request {
  get(options = {}) {
    let token = (options.isToken === undefined || options.isToken === true) ? getStore('token') : '';
    let url = '/api' + options.url;
    let promise = new Promise((resolve, reject) => {
      axios.get(
          url, {
          params: options.data,
          headers: {
            Authorization: 'Bearer ' + token
          }
        }).then(res => {

        config.debug ? console.log("get-data", JSON.stringify(res)) : '';

        if (res.data.code != 200 && res.data.code != 401) {
          Message({
            message: res.data.msg,
            type: 'error'
          })
        } else {
          resolve(res.data)
        }

        if(res.data.code == 401 && options.url != '/user/checkLogin'){

          setTimeout(function() {
            router.push({
              path: '/login'
            })
          }, 1000);

        }

      }).catch(error => {

        config.debug ? console.log('err' + JSON.stringify(error)) : '';
        let {
          message
        } = error;

        if (message == "Network Error") {
          message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
          message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
          message = "系统接口" + message.substr(message.length - 3) + "异常";
        }

        Message({
          message: message,
          type: 'error'
        })

        reject(error)

      })
    })
    return promise;
  }
  post(options = {}) {
    let url = '/api' + options.url;
    return new Promise((resolve, reject) => {
      axios.post(
        url,
        options.data, {
          headers: {
            Authorization: 'Bearer ' + options.isToken ? getStore('token') : ''

          }
        }
      ).then(res => {
        config.debug ? console.log("post-data", res) : '';
        if (res.data.code != 200 && res.data.code != 401) {
          Message({
            message: res.data.msg,
            type: 'error'
          })
        }

        if(res.data.code == 401){
          setTimeout(function() {
            router.push({
              path: '/login'
            })
          }, 1000);
        }
        resolve(res.data)

      }).catch(error => {
        config.debug ? console.log('err' + error) : '';
        let {
          message
        } = error;
        if (message == "Network Error") {
          message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
          message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
          message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        Message({
          message: message,
          type: 'error',
          duration: 5 * 1000
        })
        reject(error)
      })
    })
  }
  /**
   * @description set default request options
   * @param {Object} config - the default options
   * @param {string} config.baseUrl baseUrl - the base url
   * @param {boolean} config.debug debug - enable debug to log
   */
  setConfig(conf) {
    if(!config.isTest) {
      axios.defaults.baseURL = conf.baseUrl
    }
    config = Object.assign(config, conf)
  }
}
/**
 *
 */
var request = new Request()
/**
 * @module {Request} request
 */
export default request



//////////////////
// WEBPACK FOOTER
// ./common/request/request.js
// module id = 183
// module chunks = 0